"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdfDocument = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("@blueprintjs/core");
var lodash_1 = require("lodash");
var HeaderAndFooter_1 = require("./HeaderAndFooter");
var renderAge = function (age) {
    return (react_1.default.createElement("span", null,
        age ?
            age.years ?
                "".concat(age.years, " years")
                : null
            : null,
        age ?
            age.months ?
                " ".concat(age.months, " months")
                : null
            : null,
        age ?
            age.days ?
                " ".concat(age.days, " days")
                : null
            : null));
};
function PdfDocument(props) {
    var filterList = props.filterList;
    return (react_1.default.createElement("div", { id: "printSection", className: "relative pv4 ph4", style: { overflowY: 'scroll', visibility: 'visible', height: 'auto' } },
        react_1.default.createElement("div", { className: "flex justify-end" },
            react_1.default.createElement(core_1.Button, { id: "noprint", className: "ph4", onClick: function () {
                    document.title = "List Of Appointments on ".concat(props.date);
                    window.print();
                } }, "Print")),
        react_1.default.createElement("div", { className: "cf" },
            react_1.default.createElement("header", null,
                react_1.default.createElement(HeaderAndFooter_1.HeaderSection, { content: props.header, date: props.date })),
            react_1.default.createElement("div", { className: "relative" },
                react_1.default.createElement("ul", { style: { whiteSpace: 'pre-wrap' }, className: "list center pl0 ma0 db" }, filterList.length ?
                    filterList.map(function (appointment, index) {
                        return (react_1.default.createElement("li", { key: index, className: "b--black-10 ba br1 mb2" },
                            react_1.default.createElement("div", { className: "b--black-05 bb bg-near-white flex justify-between ph3 pv2" },
                                react_1.default.createElement("div", { className: "black-70 db di-ns f5 fw5 truncate" },
                                    index + 1,
                                    appointment.createdFrom ? "[".concat(appointment.createdFrom, "] - ") : '',
                                    appointment.patientName,
                                    appointment.info ?
                                        appointment.info.patientType ?
                                            " (".concat(appointment.info.patientType, ")")
                                            : ''
                                        : '')),
                            react_1.default.createElement("div", { className: "w-100 db pl1 pl3-ns pv2" },
                                react_1.default.createElement("div", { className: "w-100 cf" },
                                    react_1.default.createElement("div", { className: "fl w-25 pa1" },
                                        react_1.default.createElement("span", { className: "fl fw3 i" }, "Appointment Time: "),
                                        react_1.default.createElement("span", { className: "fl pl2 fw5" }, appointment.info ?
                                            appointment.info.time ?
                                                appointment.info.time.toUpperCase()
                                                : 'N/A'
                                            : 'N/A')),
                                    react_1.default.createElement("div", { className: "fl w-25 pa1" },
                                        react_1.default.createElement("span", { className: "fl fw3 i" }, "Patient Number: "),
                                        react_1.default.createElement("span", { className: "fl pl2 fw5" }, appointment.patientId)),
                                    react_1.default.createElement("div", { className: "fl w-25 pa1" },
                                        react_1.default.createElement("span", { className: "fl fw3 i" }, "Age: "),
                                        react_1.default.createElement("span", { className: "fl pl2 fw5" }, appointment.info ?
                                            appointment.info.age ?
                                                renderAge(appointment.info.age)
                                                : null
                                            : null)),
                                    react_1.default.createElement("div", { className: "fl w-25 pa1" },
                                        react_1.default.createElement("span", { className: "fl fw3 i" }, "Appointment Status: "),
                                        react_1.default.createElement("span", { className: "fl pl2 fw5" }, ((0, lodash_1.isEqual)(appointment.status, 'CONFIRMED') ||
                                            (0, lodash_1.isEqual)(appointment.status, 'PARTIAL_REFUND') ||
                                            (0, lodash_1.isEqual)(appointment.status, 'PATIENT_READY')) ?
                                            'CONFIRMED'
                                            : 'COMPLETED')),
                                    react_1.default.createElement("br", null)))));
                    })
                    :
                        (react_1.default.createElement("li", { className: "b--black-10 ba br1 mb2" },
                            react_1.default.createElement("div", { className: "pl1 pl3 pv2" },
                                react_1.default.createElement("div", { className: "w-100 cf" },
                                    react_1.default.createElement("div", { className: "fl w-third-ns w-100 pa1" },
                                        react_1.default.createElement("span", { className: "fl fw3 i" }, "Nothing Found")))))))),
            react_1.default.createElement("footer", { className: "mid-gray w-100 bt tc mt3" },
                react_1.default.createElement(HeaderAndFooter_1.FooterSection, { content: props.footer })))));
}
exports.PdfDocument = PdfDocument;
;
//# sourceMappingURL=PDFDocument.js.map